module.exports = __webpack_public_path__ + "img/logo.05f29f4e.png";